/** Default IANA timezone (US Eastern). */
export const DEFAULT_APP_TIMEZONE = "America/New_York";

const FALLBACK_TIMEZONES = [
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Phoenix",
  "America/Anchorage",
  "Pacific/Honolulu",
  "UTC",
  "Europe/London",
  "Europe/Paris",
  "Europe/Moscow",
  "Asia/Tokyo",
  "Australia/Sydney",
];

/** Sorted IANA timezone ids for select controls; falls back if unsupported. */
export function getTimezoneSelectOptions(): string[] {
  try {
    const intl = Intl as unknown as {
      supportedValuesOf?: (key: string) => string[];
    };
    if (typeof intl.supportedValuesOf === "function") {
      return [...intl.supportedValuesOf("timeZone")].sort((a, b) =>
        a.localeCompare(b),
      );
    }
  } catch {
    /* ignore */
  }
  return [...FALLBACK_TIMEZONES];
}
